module.exports = __webpack_public_path__ + "static/media/language1.e2cb1388.png";